import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Backdrop, Box, Button, ButtonGroup, CircularProgress, Typography, useMediaQuery } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2'
import Swal from 'sweetalert2'

import PriceCard from '../../../components/common/pricing/PriceCard'
import { PLAN_LIST } from '../../../components/common/pricing/plans'
import { useAuth } from '../../../context/SecurityContextProvider'
import { activateFreeTier, startCheckout } from '../../../services/api/StripeDataService'
import { onboardingStyles as s } from '../onboardingStyles'

const TIERS = PLAN_LIST

export default function PlanStep({ finishOnboarding, userType }) {
    const navigate = useNavigate()
    const { refreshUser } = useAuth()
    const isMobile = useMediaQuery('(max-width:950px)')
    const [annual, setAnnual] = useState(false)
    const [loading, setLoading] = useState(false)

    // On mobile, lead with Pro for creators (desktop keeps Light → Pro order).
    const proFirst = isMobile && userType === 'creator'

    const fail = () => {
        setLoading(false)
        Swal.fire({
            title: "Can't Proceed to Checkout",
            text: 'Something went wrong. Please try again later.',
            icon: 'error',
        })
    }

    const handleFree = async () => {
        setLoading(true)
        finishOnboarding()
        try {
            await activateFreeTier()
            await refreshUser()
            navigate('/studio')
        } catch {
            fail()
        }
    }

    const handlePro = async () => {
        setLoading(true)
        finishOnboarding()
        try {
            await startCheckout('Pro', !annual)
        } catch {
            fail()
        }
    }

    return (
        <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ ...s.title, textAlign: 'center' }}>
                Let's get you started
            </Typography>
            <Typography sx={{ fontFamily: 'Catamaran', color: 'text.gray', fontSize: '0.78rem', mb: 2 }}>
                {/* Build for free. Grow with Pro. */}
                14-day trial. Cancel anytime.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <ButtonGroup aria-label="billing period">
                    <Button
                        variant={annual ? 'outlined' : 'contained'}
                        onClick={() => setAnnual(false)}
                        sx={{ textTransform: 'none', borderRadius: '30px', fontFamily: 'Catamaran', fontSize: '.76rem' }}
                    >
                        Monthly
                    </Button>
                    <Button
                        variant={annual ? 'contained' : 'outlined'}
                        onClick={() => setAnnual(true)}
                        sx={{ textTransform: 'none', borderRadius: '30px', fontFamily: 'Catamaran', fontSize: '.76rem' }}
                    >
                        Annually
                    </Button>
                </ButtonGroup>
            </Box>

            {/* FREE and PAID PLANS */}
            {/* <Grid2 container spacing={2} justifyContent="center">
                {(() => {
                    const lightCard = <PriceCard key="light" tier={TIERS[0]} isAnnual={annual} buttonAction={handleFree} compact />
                    const proCard = <PriceCard key="pro" tier={TIERS[1]} isAnnual={annual} buttonAction={handlePro} compact />
                    return proFirst ? [proCard, lightCard] : [lightCard, proCard]
                })()}
            </Grid2> */}

            <Grid2 container spacing={2} justifyContent="center">
                <PriceCard key="pro" tier={TIERS[1]} isAnnual={annual} buttonAction={handlePro} compact />
            </Grid2>

            <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}
